module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Players/Player/Modal/img/Fail-85890c0633e62115f6c4f634ce2e09b0.svg";